var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 165 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 42.3789H23.8211V66.7608H18V42.3789Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7067 49.332V66.7287H42.4511V57.7476L38.393 63.8015H37.7277L33.6364 57.7476V66.7287H28.4141V49.332H33.6364L38.0271 55.9181L42.4179 49.332H47.7067Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.117 32L112.93 57.5128H146.392V32H119.117ZM138.376 50.9933H134.617V44.5402L131.69 48.8644H131.224L128.297 44.5402V50.96H124.539V38.5196H128.297L131.457 43.2429L134.617 38.5196H138.376V50.9933Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1016 66.7287V49.332H57.5567V66.7287H52.1016Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0859 47.1355V42.3789H57.5411V47.1688H52.0859V47.1355Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.707 61.8722H81.0687V71.4188H75.7466V66.7619H65.6346V71.4188H60.3125V61.8722H62.5744C63.539 60.4419 64.038 58.4129 64.038 55.8516V49.332H78.707V61.8722ZM68.2957 61.8722H73.3849V53.9889H69.3601V55.8183C69.3601 58.2466 68.9942 60.2756 68.2957 61.8722Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.848 66.7268H103.827L98.8713 59.176V66.7268H93.5492V59.176L88.593 66.7268H82.5391L88.593 58.0118L82.905 49.2969H88.9589L93.5492 56.7478V49.3301H98.8713V56.7811L103.462 49.3301H109.482L103.827 58.0451L109.848 66.7268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImigLogo);
export default __webpack_public_path__ + "static/media/imigLogo.4a52fd41f3e9f3ca1f861d690e1fc7c3.svg";
export { ForwardRef as ReactComponent };